import styled from 'styled-components/macro'

import { toCSSValue, type ColorToken } from '@loadsmart/miranda-react/dist/tokens'

export type VerticalDividerProps = {
  width$?: number
  height$?: number
  backgroundColor$?: ColorToken
  className?: string
}

const VerticalDividerComponent = styled.hr<VerticalDividerProps>`
  width: ${props => props.width$}px;
  height: ${props => props.height$}px;
  background-color: ${props => toCSSValue(props.backgroundColor$!)};
  border: none;
  margin: 0;
`

export function VerticalDivider({
  width$ = 1,
  height$ = 32,
  backgroundColor$ = 'color-border',
  className,
}: VerticalDividerProps) {
  return (
    <VerticalDividerComponent
      width$={width$}
      height$={height$}
      backgroundColor$={backgroundColor$}
      className={className}
    />
  )
}
